<template>
  <div id="app">
    <Menu :color="color" :key="color"/>
    <Banner/>
    <Section1 id="about" name="about"/>
    <Slider id="brands" name="brands" :title="'Our leading brands'" :data="brands" />
    <Map/>
    <Slider id="clients" name="clients" :title="'Our leading clients'" :data="clients" />
    <Services id="services" name="services"/>
    <Catalog/>
    <Contact id="contact" name="contact"/>
  </div>
</template>

<script>
import Menu from './components/Menu.vue'
import Banner from './components/HomeBanner.vue'
import Section1 from './components/Section1.vue'
import Map from './components/Map.vue'
import Slider from './components/Slider.vue'
import Services from './components/Services.vue'
import Catalog from './components/Catalog.vue'
import Contact from './components/Contact.vue'
export default {
  name: 'app',
  components: {
    Menu,
    Banner,
    Section1,
    Map,
    Slider,
    Services,
    Catalog,
    Contact
  },
  methods: {
    handleScroll(){
      var stop= document.querySelector('#about');
      if(window.scrollY > stop.offsetTop-100){
          this.color = 'dark';
      } else {
          this.color = 'light';
      }
    }
  },
  created () {
      window.addEventListener('scroll', this.handleScroll, true)
  },
  destroyed () {
      window.removeEventListener('scroll', this.handleScroll, true)
  },
  data() {
    return {
      color: 'light',
      clients: [
        require('./assets/img/clients/img_clients1.jpg'),
        require('./assets/img/clients/img_clients2.jpg'),
        require('./assets/img/clients/img_clients3.jpg'),
        require('./assets/img/clients/img_clients4.jpg'),
        require('./assets/img/clients/img_clients5.jpg'),
        require('./assets/img/clients/img_clients6.jpg'),
        require('./assets/img/clients/img_clients7.jpg'),
        require('./assets/img/clients/img_clients8.jpg'),
        require('./assets/img/clients/img_clients9.jpg'),
        require('./assets/img/clients/img_clients10.jpg'),
        require('./assets/img/clients/img_clients11.jpg'),
        require('./assets/img/clients/img_clients12.jpg'),
        require('./assets/img/clients/img_clients13.jpg'),
        require('./assets/img/clients/img_clients14.jpg'),
        require('./assets/img/clients/img_clients15.jpg')
      ],
      brands: [
        require('./assets/img/brands/img_brand1.jpg'),
        require('./assets/img/brands/img_brand2.jpg'),
        require('./assets/img/brands/img_brand3.jpg'),
        require('./assets/img/brands/img_brand4.jpg'),
        require('./assets/img/brands/img_brand5.jpg'),
        require('./assets/img/brands/img_brand6.jpg'),
        require('./assets/img/brands/img_brand7.jpg'),
        require('./assets/img/brands/img_brand8.jpg'),
        require('./assets/img/brands/img_brand9.jpg'),
        require('./assets/img/brands/img_brand10.jpg'),
        require('./assets/img/brands/img_brand11.jpg'),
        require('./assets/img/brands/img_brand12.jpg'),
        require('./assets/img/brands/img_brand13.jpg'),
        require('./assets/img/brands/img_brand14.jpg'),
        require('./assets/img/brands/img_brand15.jpg'),
        require('./assets/img/brands/img_brand16.jpg'),
        require('./assets/img/brands/img_brand17.jpg'),
        require('./assets/img/brands/img_brand18.jpg'),
        require('./assets/img/brands/img_brand19.jpg'),
        require('./assets/img/brands/img_brand20.jpg'),
        require('./assets/img/brands/img_brand21.jpg'),
        require('./assets/img/brands/img_brand22.jpg'),
        require('./assets/img/brands/img_brand23.jpg'),
        require('./assets/img/brands/img_brand24.jpg'),
        require('./assets/img/brands/img_brand25.jpg'),
        require('./assets/img/brands/img_brand26.jpg'),
        require('./assets/img/brands/img_brand27.jpg'),
        require('./assets/img/brands/img_brand28.jpg'),
        require('./assets/img/brands/img_brand29.jpg'),
        require('./assets/img/brands/img_brand30.jpg'),
        require('./assets/img/brands/img_brand31.jpg'),
        require('./assets/img/brands/img_brand32.jpg'),
      ]
    }
  }
}
</script>

<style>
#app {
  font-family: "effra", sans-serif;
  font-weight: 400;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #000000;
}
/* ALIGN */
.centerv{
  align-self: center;
}
.bottomv{    
  align-self: end;
}
/* TEXT */
p{
  font-size: 30px;
}

h1{
    font-size: 60px !important;
    font-weight: 400 !important;
}
.red{
    color: #C80B4B;
}

/* SLIDER */
.slick-dots li button:before {
    opacity: 1;
    color: #E5E5E5;
    font-size: 11px;
}
.slick-dots li.slick-active button:before {
    opacity: 1;
    color: #C80B4B;
}

/* SLIDER BANNER*/
#banner .slick-dots{
   bottom: 5%;
   text-align: right;
   padding-right: 5%;
}

.navbar-toggler-icon{
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 1%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e") !important;
}

@media (max-width: 1600px){
  h1{
    font-size: 45px  !important;
  }
  p{
    font-size: 23px;
  }
  h2{
    font-size: 39px !important;
  }
}
@media (max-width: 968px){
  .slick-dots{
    display: none !important;
  }
}

@media (max-width: 768px){
  h1{
    font-size: 30px !important;
  }
  h2{
    font-size: 27px !important;
  }
}
</style>
